import { render, staticRenderFns } from "./BillView.vue?vue&type=template&id=234ef0f0&scoped=true"
import script from "./BillView.vue?vue&type=script&lang=js"
export * from "./BillView.vue?vue&type=script&lang=js"
import style0 from "./BillView.vue?vue&type=style&index=0&id=234ef0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ef0f0",
  null
  
)

export default component.exports